export default __webpack_public_path__ + "static/media/send-rounded.b0a49345.svg";